import { render, staticRenderFns } from "./duzeltme_detay.vue?vue&type=template&id=23d99e9c&"
import script from "./duzeltme_detay.vue?vue&type=script&lang=js&"
export * from "./duzeltme_detay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports